import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { toggleDisruptionModals, openCreateDisruption, deleteAffectedEntities } from '../../../../../redux/actions/control/disruptions';
import { isModalOpen } from '../../../../../redux/selectors/activity';
import LeaveFormConfirmation from '../../../../Common/LeaveFormConfirmation/LeaveFormConfirmation';

const Cancellation = (props) => {
    const handleKeepEditing = () => {
        props.toggleDisruptionModals('isCancellationOpen', false);
    };

    const handleDiscard = () => {
        props.openCreateDisruption(false);
        props.deleteAffectedEntities();
        props.toggleDisruptionModals('isCancellationOpen', false);
    };

    return (
        <LeaveFormConfirmation
            onKeepEditing={ handleKeepEditing }
            onDiscard={ handleDiscard }
        />
    );
};

Cancellation.propTypes = {
    toggleDisruptionModals: PropTypes.func.isRequired,
    openCreateDisruption: PropTypes.func.isRequired,
    deleteAffectedEntities: PropTypes.func.isRequired,
};

export default connect(state => ({
    isModalOpen: isModalOpen(state),
}), { toggleDisruptionModals, openCreateDisruption, deleteAffectedEntities })(Cancellation);
